import { useContext, useEffect, useState } from 'react';
import { DataAccessContext } from '@chargify/data-access';
import { ComponentsSettingsKeys, MergedSettings } from './types';
import { SessionContext } from '../SessionGuard/index';

export const useSettings = <T extends { [K in ComponentsSettingsKeys]?: T[K] }>(
  clientSettings: T
): MergedSettings<T> => {
  const [settings, setSettings] = useState<MergedSettings<T>>(null);
  const { dataAccess } = useContext(DataAccessContext);
  const { sessionInitialized } = useContext(SessionContext);

  useEffect(() => {
    async function getSettings() {
      const data = await dataAccess.getBillingPortalSettings();
      const dataWithBillingHistory = {
        ...data,
        billingHistory: {},
      };
      const mergedSettingsObject = Object.keys(dataWithBillingHistory).reduce(
        (acc, key: ComponentsSettingsKeys) => {
          return {
            ...acc,
            [key]: {
              ...clientSettings[key],
              ...dataWithBillingHistory[key],
            },
          };
        },
        dataWithBillingHistory
      );
      setSettings(mergedSettingsObject);
    }
    if (sessionInitialized) getSettings();
  }, [clientSettings, dataAccess, sessionInitialized]);

  return settings;
};
